export const cmsCfgapiUrlAdapter = (url: string): string => {
  // Check if the request is for cfgapi
  const isCfgapi = url.includes('/cfgapi/hst/menus')
  const loc = window.location?.href ? new URL(window.location.href) : null
  const isCmsSubdomain =
    loc && /^cms([-.a-zA-Z0-9]*)\.ameriprise\.com$/.test(loc.hostname)
  const isAdvisorDomain = loc && /ameripriseadvisors?\.com$/.test(loc.hostname)

  // Insert 'site/_cmsinternal/' before 'cfgapi' in the pathname if not already present
  if (isCfgapi && isCmsSubdomain) {
    const urlObj = new URL(url, loc)
    if (!urlObj.pathname.includes('/site/_cmsinternal/')) {
      urlObj.pathname = urlObj.pathname.replace(
        /\/cfgapi/,
        '/site/_cmsinternal/cfgapi'
      )
    }
    return urlObj.toString()
  }

  // If request is from ameripriseadvisors.com, change domain to ameriprise.com
  if (isCfgapi && isAdvisorDomain) {
    const urlObj = new URL(url, loc)
    urlObj.hostname = urlObj.hostname.replace(
      'ameripriseadvisors.com',
      'ameriprise.com'
    )
    return urlObj.toString()
  }

  return url
}
